import { MLPBatches, MLPCategory } from '../MLPContext'
import { MLPResult } from '../MLPStore'

export const getTotalCasesFromBatches = (batches: MLPBatches) => {
    return batches.reduce((total: any, batch: string | any[]) => {
        return total + batch.length
    }, 0)
}
export const getTotalCasesFromBatch = (batches: MLPBatches, batchIndex: number) => {
    return batches[batchIndex].length
}

export const getTotalResults = (results: MLPResult[][]) => {
    return results.reduce((total: any, batch) => {
        return total + batch.filter((caseItem) => caseItem).length
    }, 0)
}
export const getAmountofCurrentBatchFinishedItems = (results: MLPResult[][], batchIndex: number) => {
    const result = results[batchIndex]
    if (result) {
        return result.filter((caseItem) => caseItem).length
    }
    return 0
}
export const findTotalAmountOfCasesWithCategory = (
    results: MLPResult[][],
    batchIndex: number,
    category: MLPCategory
) => {
    const resultsAtBatch = results[batchIndex]
    if (resultsAtBatch) {
        return resultsAtBatch.filter((result) => result.category === category).length || 0
    } else {
        return 0
    }
}

export const findTotalAmountOfCasesWithCategoryInAllBatches = (results: MLPResult[][], category: MLPCategory) => {
    return results.reduce((total: any, batch) => {
        return total + batch?.filter((result) => result.category === category).length
    }, 0)
}
